import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes,Route } from 'react-router-dom';

import Login from './Login.js';
import App from './App.js';
import View from './View.js';
import TagView from './TagView.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
        <Route exact path="/" element={<Login/>}/>
        <Route exact path="/App" element={<App/>}/>
        <Route exact path="/Viewer" element={<View/>}/>
        <Route exact path="/Tag" element={<TagView/>}/>
    </Routes>
  </BrowserRouter>
);

export function setSS(name,content){
  localStorage.setItem(name,content)
}
export function getSS(name){
  return localStorage.getItem(name)
}

export function isMobile(){
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
} 

const test = false
const useMainDB = false
export function mainDB(){
  return useMainDB
}


export function client_url(){
  return test?"http://localhost:3000/":"https://parodewnova.com/"
}
export function server_URL(){
  if (!useMainDB&&test){
    return "http://localhost:8000/"
  }
  return "https://api.parodewnova.com/"
}
export function upload_URL(){
  return test?"http://localhost:8000/upload":"https://api.parodewnova.com/upload"
}
export function construct_URL(){
  return test?"http://localhost:8000/construct":"https://api.parodewnova.com/construct"
}


export const sortingTypes = ["date_created","last_updated"]
export const sortingTypes2 = ["ascending","descending"]



// const upload_URL = "https://api.parodewnova.com/upload"
// const construct_URL = "https://api.parodewnova.com/construct"

// export const client_url = "http://192.168.68.51:3000/"
// export const server_URL = "http://192.168.68.51:8000/"
// export const client_url = "https://parodewnova.com/"
// export const server_URL = "https://api.parodewnova.com/"